import { Col, Icon, Row } from "antd";
import React from "react";
import styles from "./ModalTitle.module.scss";
import { ModalTitleProps } from "./ModalTitleModel";

function ModalTitle(props: ModalTitleProps) {
  return (
    <Row>
      <Col xs={24} className={styles.ModalTitleLabel}>
        {props.children}
      </Col>
      <div className={styles.ModalTitleCancel} onClick={props.onCancel}>
        <Icon type="close-circle" theme="filled" />
      </div>
    </Row>
  );
}

export default ModalTitle;
